import Home from '../views/Home/Index.vue'
import FinalPage from '../views/FinalPage/Index.vue'
import Offers from '../views/Offers/Index.vue'

/// compilation of all routes into an variable
export default {
    children: [
        {
            path: '/',
            component: Home,
            meta: {
              requiresAuth: true,
              title: 'Home',
              breadcrumb: [
                {name: 'Home', link: '/', showLink: true},
              ]
            }
        },
        {
          path: '/presupuesto',
          component: FinalPage,
          meta: {
            requiresAuth: true,
            title: 'Home',
            breadcrumb: [
              {name: 'Home', link: '/', showLink: true},
            ]
          }
      },
      {
        path: '/offers',
        component: Offers,
        meta: {
          requiresAuth: true,
          title: 'Home',
          breadcrumb: [
            {name: 'Home', link: '/', showLink: true},
          ]
        }
    }/*,       
        {
            path: '/*',
            component: Error404,
            meta: {
              requiresAuth: false,
              title: 'message.purchaseOrders',
              breadcrumb: []
            }
        }*/,
    ]
}


// WEBPACK FOOTER //
// ./src/router/routes.js